import React, { useEffect, useState, useRef } from "react";
import { Layout, Affix, message, Modal } from 'antd';
import Settings from "../admin/Settings";
import moment from "moment";
import Site from "../site/Site";
import { apiCall } from "../utils/Api";
import { usePrefs } from "../utils/Prefs";
import LiveToggle from "../utils/LiveToggle";

export default function DefaultLayout(props) {

    const { templates = [] } = props;
    const [view, setView] = useState("desktop");
    const [page, setPage] = useState({})
    const [menus, setMenus] = useState([]);
    const [content, setContent] = useState([])
    const [editing, setEditing] = useState(false);
    const [selected, setSelected] = useState("");
    const [globals, setGlobals] = useState([])
    const [globalTarget, setGlobalTarget] = useState(false);
    const [prefs, setPrefs] = usePrefs();
    const [filters, setFilters] = useState({
        visible: true,
        hidden: true,
        test: true,
        scheduled: true,
    })

    const containerRef = useRef(null);



    const [modalOpen, setModalOpen] = useState(false)

    const checkForUsers = (warn = true) => {


        apiCall("site_content/setLocation", { menu_id: page.id, editing_styles: prefs.changed }, (_status, _result) => {
            if (_status) {

           
                if(!warn){
                    return;
                }
                
                let _onpage = _result.filter(item => item.menu_id === page.id);
                let _names_on_page = "";
                if (_onpage.length > 0) {
                    _names_on_page = _onpage.map(item => item.name).join(", ");
                }

                let _editing = _result.filter(item => item.editing_styles === true)
                let _name_editing = ""
                if (prefs.changed && _editing.length > 0) {
                    _name_editing = _editing.map(item => item.name).join(", ");
                }

                if (modalOpen) {
                    return;
                }

                if (_names_on_page || _name_editing) {

                    setModalOpen(true);

                    let _usermsg = (_names_on_page) ? <div>User(s): <strong>{_names_on_page}</strong> are currently editing this page.</div> : <></>;
                    let _editmsg  = (_name_editing) ? <div>User(s): <strong>{_name_editing}</strong> are currently editing styles.</div> : <></>;

                    Modal.warning({
                        title: "Warning",
                        content: <>{_usermsg}{_editmsg}</>,
                        onOk: () => {
                            setModalOpen(false)
                        }
                    })
                    return;
                }

            } else {
             
                console.error(_result.error)
            }
        })
    }

    useEffect(() => {
        // Set up interval for subsequent fetches every 45 seconds
        const interval = setInterval(() => {
            checkForUsers(false);
        }, 45000);

        // Clean up interval on component unmount
        return () => clearInterval(interval);
    })

    useEffect(() => {
        if (!page.hasOwnProperty("id")) { return; }
        checkForUsers();
    }, [page, prefs.changed])


    // Fetch the global components - these only need to be fetched once and when updated - don't need re-run on page changes like getContent
    const getGlobals = (_skip = false) => {

        // Globals already loaded => fetch content
        if (globals.find(item => item.component === "search_bar" && !_skip)) {
            getContent();
            return;
        }

        apiCall("site_content/getContent", {}, (_status, _result) => {
            if (_status) {

                let _search_bar = _result.find(item => item.component === "search_bar");
                let _nav_bar = _result.find(item => item.component === "nav_bar");
                let _footer_bar = _result.find(item => item.component === "footer_bar");

                // Overide the default object's data, date_changed & container values
                setPrefs({
                    ...prefs,
                    "search_bar": { ...prefs.search_bar, "data": (_search_bar) ? _search_bar.data : prefs.search_bar.data, "container": (_search_bar) ? _search_bar.container : prefs.search_bar.container, "date_changed": (_search_bar) ? _search_bar.date_changed : prefs.search_bar.date_changed },
                    "nav_bar": { ...prefs.nav_bar, "data": (_nav_bar) ? _nav_bar.data : prefs.nav_bar.data, "container": (_nav_bar) ? _nav_bar.container : prefs.nav_bar.container, "date_changed": (_nav_bar) ? _nav_bar.date_changed : prefs.nav_bar.date_changed },
                    "footer_bar": { ...prefs.footer_bar, "data": (_footer_bar) ? _footer_bar.data : prefs.footer_bar.data, "container": (_footer_bar) ? _footer_bar.container : prefs.footer_bar.data, "date_changed": (_footer_bar) ? _footer_bar.date_changed : prefs.footer_bar.date_changed }
                })

                setGlobals(_result);
                getContent();
            } else {
                message.error(_result.error)
            }
        })
    }
    useEffect(getGlobals, [page]);

    // Fetch the content when the page changes, push the searchbar, nav and footer
    const getContent = () => {
        if (!page.hasOwnProperty("id")) { return; }
        apiCall("site_content/getContent", { page_id: page.id }, (_status, _result) => {
            if (_status) {
                setContent(_result);
            } else {
                message.error(_result.error)
            }
        })
    }


    // Update globals
    const updateGlobals = (_items, _location = "global") => {


        // Not sure what this was about, but keeping it just in case 
        //let m = globals.filter(item => item.component !== "search_bar" && item.component !== "nav_bar" && item.component !== "footer_bar")
        // _items = _items.concat(m);

        let obj = {
            location: _location,
            content_json: JSON.stringify(_items)
        }

        console.log(_items);;

        apiCall("site_content/updateContent", obj, (_status, _result) => {
            if (_status) {
                setGlobals(_result);
            } else {
                message.error(_result.error);
            }
        })
    }

    // Update content, cull the searchbar, nav and footer
    const updateContent = (_items, _location = "main") => {



        _items = _items.filter(item => item.component !== "nav_bar" && item.component !== "search_bar" && item.component !== "footer_bar");

        let obj = {
            page_id: page.id,
            location: _location,
            content_json: JSON.stringify(_items)
        }

        apiCall("site_content/updateContent", obj, (_status, _result) => {
            if (_status) {
                setContent(_result);
            } else {
                message.error(_result.error);
            }
        })
    }

    // Check if now is within a start and end date - bool (maybe moment.js has this method?)
    const isNowInRange = (start_date, end_date) => {
        const current_time = moment().unix();
        if (start_date !== null && current_time < start_date) {
            return false;
        }
        if (end_date !== null && current_time > end_date) {
            return false;
        }
        return true;
    }

    // Show / hide content during preview based on the selected preferences
    const filterContent = (_content) => {

        if (open) {
            return _content;
        }
        let _c = [...content];

        if (!filters.visible) {
            _c = _c.filter(item => item.visibility !== "visible")
        }

        if (!filters.test) {
            _c = _c.filter(item => item.visibility !== "test")
        }

        if (!filters.hidden) {
            _c = _c.filter(item => item.visibility !== "hidden")
        }

        if (!filters.scheduled) {
            _c = _c.filter(item => isNowInRange(item.start_date, item.end_date));
        }

        return _c;
    }

    // Wrapper for desktop, tablet and mobile views (does not respect media queries)
    const wrapView = () => {

        let w = "1248px";
        switch (view) {
            case "desktop":
                w = { "width": "100%", "overflow": "auto" };
                break;
            case "tablet":
                w = { "width": "768px", "margin": "0 auto" };
                break;
            case "phone":
                w = { "width": "375px", "margin": "0 auto" };
                break;
            default:
                w = { "width": "100%", "overflow": "auto" };
                break;
        }

        return (
            <div className={(view === "desktop" ? "" : "bm_mobile")} style={w}>
                <div className="shadow" style={{ "backgroundColor": "#fff" }}>
                    <Site getMenu={getMenu} globalTarget={globalTarget} containerRef={containerRef} setGlobals={setGlobals} globals={globals} selected={selected} setSelected={setSelected} setContent={setContent} content={filterContent(content)} updateContent={updateContent} updateGlobals={updateGlobals} getContent={getContent} getGlobals={getGlobals} setEditing={setEditing} editing={editing} page={page} setPage={setPage} menus={menus} open={open} setView={setView} view={view} />
                </div>
            </div>
        )
    }



    const setToOpenPage = (_result = menus) => {

        let _parents = _result.filter(item => item.parent_id).map(item => item.parent_id);
        // find an open top-level
        let _find = _result.find(item => !item.parent_id && !_parents.includes(item.id));

        if (_find) {
            setPage(_find);
        } else {
            // find a second-level as a backup
            let _find2 = _result.find(item => !_parents.includes(item.id));
            if (_find2) {
                setPage(_find);
            } else {
                // set empty
                setPage({});
            }
        }

    }

    const convert = () => {
        apiCall("site_content/convertV1ToV3", {}, (_status, _result) => {
            if (_status) {
                fetchNavigation();
            } else {
                message.error(_result.error)
            }
        })
    }

    const getMenu = (_id) => {
        apiCall("site_content/getMenus", {}, (_status, _result) => {
            if (_status) {
                setMenus(_result);
                let _find = _result.find(item => item.id === _id);
                if (_find) {
                    setPage(_find);
                }
            }
        })
    }

    const fetchNavigation = () => {
        apiCall("site_content/getMenus", {}, (_status, _result) => {
            if (_status) {
                if (_result.length === 0) {

                    Modal.confirm({
                        title: "Start using content creator?",
                        content: "This will copy over your site navigation - Going forward, you will only be able to make changes to your navigation from the content creator.",
                        onOk: () => convert(),
                        onCancel: () => window.location = "https://biz.bookmanager.com/"
                    })
                } else {
                    setToOpenPage(_result);
                    setMenus(_result)
                }
            }
        })
    }

    useEffect(fetchNavigation, []);


    const [open, setOpen] = useState(true);

    return (
        <>
            <Layout>
                <Affix offsetTop={0}>
                    <div style={{ "width": (open && !editing) ? "300px" : "0px", "height": "0px" }}>&nbsp;</div>
                    <Layout.Sider theme="light" width={300} style={{ "marginLeft": (open && !editing) ? 0 : -300, "height": "100vh", "zIndex": "501" }} className="settingsPanel shadow" >
                        <div>
                            <Settings templates={templates} editing={editing} filters={filters} setFilters={setFilters} globalTarget={globalTarget} setGlobalTarget={setGlobalTarget} updateContent={updateContent} selected={selected} setSelected={setSelected} setContent={setContent} content={content} page={page} setPage={setPage} setToOpenPage={setToOpenPage} menus={menus} setMenus={setMenus} view={view} setView={setView} open={open} setOpen={setOpen} />
                        </div>
                    </Layout.Sider>
                </Affix>
                <Layout>
                    <div ref={containerRef} id="bm-scroll-area" className={(globalTarget) ? "pattern-global" : "pattern-local"} style={{ "padding": (open) ? "30px" : "0px", "height": "100vh", "overflow": "scroll" }}>
                        <div className="float-flex">
                            {wrapView()}
                            <div className={(editing) ? "editbox opened" : "editbox"} id="editBox">
                            </div>
                        </div>
                    </div>
                </Layout>
            </Layout>
            <LiveToggle />
        </>
    )

}